<template>
  <div class="select-data">
    <el-dialog title="七天预报" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body=false ref="cxtjRef"
      :before-close="() => params.flag && $parent.toggleProductView(params.productInfo.code)">
      <div slot="title" class="select-header">
        <span>七天预报</span>
        <span>更新时间：{{ ptimestemp }}</span>
      </div>
      <div class="content-wrap">
        <div id="seven-echart"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import echarts from '@/config/echarts/index.js'
import { getDaysForecastOption } from '@/config/echarts/option/seven-day'
import { mapState } from 'vuex'
import { apiData } from '../api/index'

export default {
  props: ['params'],
  data () {
    return {
      myEchart: null,
      ptimestemp: ''
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
        this.$nextTick(() => {
          if (this.myEchart) {
            this.myEchart.resize()
          }
        })
      },
      immediate: true
    },
    activeCountyId: {
      handler () {
        setTimeout(() => {
          this.getSevenData()
        }, 1000)
      }
    }
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId', 'giftDataResult'])
  },
  mounted () {
    this.$nextTick(() => {
      this.getSevenData()
    })

    window.addEventListener('resize', () => {
      this.myEchart.resize()
    })
  },
  methods: {
    async getSevenData () {
      const index = this.objsList.findIndex(item => item.id === this.activeCountyId)
      const lon = (Math.round(this.objsList[index].lat / 0.05) * 0.05).toFixed(2).replace(/\./g, '')
      const lat = (Math.round(this.objsList[index].lon / 0.05) * 0.05).toFixed(2).replace(/\./g, '')
      const res = await apiData.getSevenDay(lat, lon)
      this.ptimestemp = this.$moment(res.ptimestemp).format('YYYY年MM月DD日HH时mm分')
      const start = res.ptimestemp + 3600000
      const sevenData = {
        x: [],
        temp: [],
        desc: [],
        icon: [],
        rain: []
      }
      for (let i = 0; i < 14; i++) {
        let step = i * (6 * 2)
        const time1 = start + 3600000 * step
        if (step > 71) {
          step = step - 1
        }
        sevenData.x.push(time1)
        sevenData.temp.push(res.gift_t[step])
        sevenData.desc.push(res.gift_desc[step])
        sevenData.icon.push(parseInt(res.gift_icon[step]).toString())
        sevenData.rain.push(res.gift_rain[step])
      }

      // console.log('sevenData.icon', sevenData.icon)

      if (!this.myEchart) {
        this.myEchart = echarts.init(document.getElementById('seven-echart'))
      }
      // 多天预报温度曲线图
      const option = getDaysForecastOption(sevenData.icon, sevenData.desc, sevenData.x)
      option.xAxis.data = sevenData.x
      option.series[0].data = sevenData.temp
      option.series[1].data = sevenData.rain
      option.series[2].data = sevenData.temp
      console.log('sevenData.icon', sevenData.icon)
      sevenData.icon.forEach((item, index) => {
        option.series[2].value = item
        console.log('item', item)
        option.series[2].label.rich[index] = {
          color: 'red',
          backgroundColor: {
            image: require(`@/assets/images/weatherIcon_p/${item}.png`)
          },
          // fontSize: 110,
          height: 50
        }
      })

      option.yAxis[0].max = Math.floor(Math.max(...sevenData.temp) + 3)
      option.yAxis[0].min = Math.floor(Math.min(...sevenData.temp) - 3)
      option.yAxis[1].max = Math.floor(Math.max(...sevenData.rain) + 3) > 5 ? Math.floor(Math.max(...sevenData.rain) + 3) : 5

      let bday = ''
      const markPointData = []
      option.xAxis.data.forEach((item, index) => {
        const day = this.$moment(item).format('DD')
        if (bday !== day && index !== 0) {
          markPointData.push({ coord: [index, option.series[0].data[index]], value: day + '日', y: 50 })
        }
        bday = day
      })
      option.series[0].markPoint.data = markPointData
      console.log(option)

      // option.legend.selected = { 温度: true, 雨量: true, 天气现象: false }
      this.myEchart.setOption(option)
      // setTimeout(() => {
      //   this.myEchart.setOption(option)
      //   this.$nextTick(() => {
      //     this.myEchart.resize()
      //   })
      // }, 10)
      this.$nextTick(() => {
        this.myEchart.resize()
      })
    },
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.cxtjRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.select-data {
  display: flex;
  flex-direction: column;
  pointer-events: none;
  .select-header{
    display: flex;
    justify-content: space-between;
    padding-right: 2.6vw;
    color: #FFF;
    span:nth-child(1){
      font-size: 0.94vw;
      font-weight: 600;
      color: #FFF;
    }
    span:nth-child(2){
      font-size: 0.73vw;
    }
  }
  .content-wrap{
    display: flex;
    width: 100%;
    height: 100%;
      #seven-echart{
        flex: 1;
      }
  }

  /deep/.el-dialog__wrapper {
    overflow: hidden;
    .el-dialog {
      width: 70.13rem;
      height: 70vh;
      pointer-events: auto;
      vertical-align: middle;
    }
  }
}
</style>
